export default __webpack_public_path__ + "static/media/11.285d78c2.png";